import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { useNavigate } from '@tanstack/react-router'

interface GlobalErrorPageProps {
  errorTitle?: string
  errorMessage?: string
  noReloadButton?: boolean
  customContent?: ReactNode
}

export function GlobalErrorPage(props?: GlobalErrorPageProps) {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-[70vh] flex-col justify-center bg-background px-4 py-12 sm:px-6 lg:px-8">
      <div className="mx-auto min-w-[300px] w-full max-w-md text-center bg-gray-100 rounded-xl px-4 md:px-8 py-8">
        <h1 className="mt-4 text-5xl font-bold tracking-tight text-foreground">{props?.errorTitle || 'Oops!'}</h1>
        <p className="mt-4 text-lg text-muted-foreground font-semibold text-gray-500">{props?.errorMessage || 'An Error Occured'}</p>

        {!props?.noReloadButton
          ? (
              <div className="flex items-center justify-center mt-8">
                <Button className="font-semibold" onClick={() => navigate({ reloadDocument: true })}>Reload App</Button>
              </div>
            )
          : null}
        {props?.customContent}
      </div>
    </div>
  )
}
